export interface DeviceInfo {
  platform: string;
  device: string;
  browser: string;
  browserVersion: string;
  phoneModel: string;
  os: string;
  osVersion: string;
  appVersion: string;
}

export const EMPTY_DEVICE_INFO: DeviceInfo = {
  platform: '',
  device: '',
  browser: '',
  browserVersion: '',
  phoneModel: '',
  os: '',
  osVersion: '',
  appVersion: '',
};
